/**
 * Labstep
 */

import { ColDef } from 'labstep-web/core/DataGrid/types';
import colDefEntityUser from 'labstep-web/grid/Index/coldefs/Entity/entityUser';
import { colDefResourceItemAmount } from 'labstep-web/grid/Index/coldefs/ResourceItem/amount';
import { getResourceItemMetadataColDefs } from 'labstep-web/grid/Index/coldefs/ResourceItem/metadata';
import { getResourceItemResourceMetadataColDefs } from 'labstep-web/grid/Index/coldefs/ResourceItem/metadata/resource';
import { colDefResourceItemNameNoLink } from 'labstep-web/grid/Index/coldefs/ResourceItem/name/noLink';
import { colDefResourceItemResourceNoLink } from 'labstep-web/grid/Index/coldefs/ResourceItem/resource/noLink';
import colDefResourceLocation from 'labstep-web/grid/Index/coldefs/ResourceItem/resourceLocation';
import colDefResourceItemStatus from 'labstep-web/grid/Index/coldefs/ResourceItem/status';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import { Resource } from 'labstep-web/models/resource.model';

export default (
  resource?: Resource | null,
  resourceTemplate?: Resource | null,
): (ColDef<ResourceItem> | ColDef<Resource>)[] => {
  let itemMetadataColDefs: (
    | ColDef<ResourceItem>
    | ColDef<Resource>
  )[] = [];

  let resourceMetadataColDefs: (
    | ColDef<ResourceItem>
    | ColDef<Resource>
  )[] = [];

  if (resource?.resource_item_template) {
    itemMetadataColDefs = getResourceItemMetadataColDefs(resource);
  } else if (resourceTemplate?.resource_item_template) {
    itemMetadataColDefs =
      getResourceItemMetadataColDefs(resourceTemplate);
  }

  if (resourceTemplate && !resource) {
    resourceMetadataColDefs =
      getResourceItemResourceMetadataColDefs(resourceTemplate);
  }

  const colDefs = [
    colDefResourceItemNameNoLink,
    colDefResourceLocation,
    colDefResourceItemAmount,
    ...(resource ? [] : [colDefResourceItemResourceNoLink]),
    ...itemMetadataColDefs,
    ...resourceMetadataColDefs,
    colDefEntityUser,
    colDefResourceItemStatus,
  ];

  return colDefs;
};
